import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Avatar,
  Button,
  CardActions,
  FormControl,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  Link,
  TextField,
} from "@mui/material";
import Card from "@mui/material/Card";
import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";
import React, { useState, useEffect } from "react";
import apple from "../../Assets/apple.png";
import facebook from "../../Assets/facebook.png";
import google from "../../Assets/google.png";
import "../style.css";
import SignUp from "./Signup";
import axios from "axios";
import { useDispatch } from "react-redux";
import { API_URL } from "../../consts";
import { useLocation, useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";
import { CognitoHostedUIIdentityProvider } from "@aws-amplify/auth";
import { isValidRedirectUrl, getSafeRedirectUrl } from "../../utils/redirectValidation";
import { clearAllCognitoCookies, cleanupUnnecessaryCookies } from "../../utils/authUtils";


const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    email: "",
    showPassword: false,
    password: "",
  });


  const location = useLocation();

  const [formError, setFormError] = useState("");
  const [errObj, setErrObj] = useState({ email: "" });

  const [emailValidated, setEmailValidated] = useState(true);
  const [continue_, setContinue_] = useState(false);
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [newUserLoginDisabled, setNewUserLoginDisabled] = useState(false);
  const params = new URLSearchParams(location.search);

  // Forgot-password (Amplify reset) flow
  const [forgotMode, setForgotMode] = useState(false);
  const [forgotStep, setForgotStep] = useState(1); // 1: enter email, 2: enter code + new password
  const [forgotEmail, setForgotEmail] = useState("");
  const [resetCode, setResetCode] = useState("");
  const [forgotNewPassword, setForgotNewPassword] = useState("");
  const [forgotShowPassword, setForgotShowPassword] = useState(false);
  const [forgotSubmitting, setForgotSubmitting] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const previousUrl = document.referrer;

  const handleFormChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleEnterEvent = (e) => {
    if (e.key === "Enter") {
      signIn();
    }
  };
  const handleEnterEventEmail = (e) => {
    if (e.key === "Enter") {
      continueWithEmail();
    }
  };
  const validateEmail = (email) => {
    if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    }
    return false;
  };
  const continueWithEmail = () => {
    let val = validateEmail(form.email);
    setEmailValidated(val);
    setContinue_(true);
    setErrObj({ email: !val });
  };

  const handleClickShowPassword = () => {
    setForm({
      ...form,
      showPassword: !form.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (previousUrl) {
      try {
        const previousUrlObj = (previousUrl && previousUrl !== 'null') ? new URL(previousUrl) : null;
        
        // Only trust referrer if it's from the same origin to prevent open redirect
        if (previousUrlObj && previousUrlObj.origin === window.location.origin) {
          const pathname = previousUrlObj.pathname;
          const search = previousUrlObj.search || '';
          const fullPath = pathname + search;
          
          // Validate pathname using centralized validation utility
          if (pathname && isValidRedirectUrl(fullPath)) {
            localStorage.setItem('redirectAfterLogin', fullPath);
          } else {
            console.warn('Invalid referrer pathname blocked:', fullPath);
          }
        } else if (previousUrlObj) {
          console.warn('External referrer ignored for security:', previousUrlObj.origin);
        }
      } catch (error) {
        console.error('Error parsing referrer URL:', error);
      }
    }

  }, [previousUrl])
  const signInWithGoogle = async () => {
    if (maintenanceMode) {
      setFormError("Maintenance Mode");
      return;
    }
    try {
      // Use standard Amplify federatedSignIn method
      // The logout flow will ensure Google session is cleared, forcing account selection
      await Auth.federatedSignIn({
        provider: CognitoHostedUIIdentityProvider.Google
      });

    } catch (error) {
      console.error('Error during Google sign-in:', error);
      const errorMessage = error.message || error.toString() || '';
      
      // Check for maintenance mode errors from Cognito post_authentication trigger
      if (errorMessage.includes('MAINTENANCE_MODE') || error.response?.status === 503 || error.response?.data?.error === 'maintenance_mode') {
        setMaintenanceMode(true);
        setFormError("Maintenance Mode - The website is currently under maintenance. Please try again later.");
      } else if (errorMessage.includes('NEW_USER_REGISTRATION_DISABLED') || error.response?.status === 503 || error.response?.data?.error === 'new_user_login_disabled') {
        setNewUserLoginDisabled(true);
        setFormError("Maintenance Mode - New user registration is temporarily unavailable. Please try again later.");
      } else if (errorMessage.includes('LOGIN_DISABLED')) {
        setMaintenanceMode(true);
        setFormError("Maintenance Mode - Login is temporarily unavailable. Please try again later.");
      } else {
        // Generic error - show Cognito error or default message
        setFormError(errorMessage || "Failed to sign in with Google. Please try again.");
      }
    }
  };


  const signInWithApple = async () => {
    if (maintenanceMode) {
      setFormError("Maintenance Mode - The website is currently under maintenance. Please try again later.");
      return;
    }
    try {
      await Auth.federatedSignIn({
        provider: CognitoHostedUIIdentityProvider.Apple,
      });
    } catch (error) {
      console.error('Error during Apple sign-in:', error);
      const errorMessage = error.message || error.toString() || '';

      if (errorMessage.includes('MAINTENANCE_MODE') || error.response?.status === 503 || error.response?.data?.error === 'maintenance_mode') {
        setMaintenanceMode(true);
        setFormError("Maintenance Mode - The website is currently under maintenance. Please try again later.");
      } else if (errorMessage.includes('NEW_USER_REGISTRATION_DISABLED') || error.response?.status === 503 || error.response?.data?.error === 'new_user_login_disabled') {
        setNewUserLoginDisabled(true);
        setFormError("Maintenance Mode - New user registration is temporarily unavailable. Please try again later.");
      } else if (errorMessage.includes('LOGIN_DISABLED')) {
        setMaintenanceMode(true);
        setFormError("Maintenance Mode - Login is temporarily unavailable. Please try again later.");
      } else {
        setFormError(errorMessage || "Failed to sign in with Apple. Please try again.");
      }
    }
  };

  const signInWithFacebook = async () => {
    if (maintenanceMode) {
      setFormError("Maintenance Mode - The website is currently under maintenance. Please try again later.");
      return;
    }
    try {
      await Auth.federatedSignIn({
        provider: CognitoHostedUIIdentityProvider.Facebook,
      });
    } catch (error) {
      console.error('Error during Facebook sign-in:', error);
      const errorMessage = error.message || error.toString() || '';
      
      // Check for maintenance mode errors from Cognito post_authentication trigger
      if (errorMessage.includes('MAINTENANCE_MODE') || error.response?.status === 503 || error.response?.data?.error === 'maintenance_mode') {
        setMaintenanceMode(true);
        setFormError("Maintenance Mode - The website is currently under maintenance. Please try again later.");
      } else if (errorMessage.includes('NEW_USER_REGISTRATION_DISABLED') || error.response?.status === 503 || error.response?.data?.error === 'new_user_login_disabled') {
        setNewUserLoginDisabled(true);
        setFormError("Maintenance Mode - New user registration is temporarily unavailable. Please try again later.");
      } else if (errorMessage.includes('LOGIN_DISABLED')) {
        setMaintenanceMode(true);
        setFormError("Maintenance Mode - Login is temporarily unavailable. Please try again later.");
      } else {
        setFormError(errorMessage || "Failed to sign in with Facebook. Please try again.");
      }
    }
  };

  const signIn = () => {
    if (maintenanceMode) {
      setFormError("Maintenance Mode");
      return;
    }
    let { email, password } = form;
    try {
      const user = Auth.signIn(form.email, form.password)
        .then((res) => {
          Auth.currentSession().then(async (data) => {
            dispatch({
              type: "SET_TOKEN_IN_PROCESS",
              payload: false,
            });
            let accessT = data.accessToken.getJwtToken();
            axios.defaults.headers.common["Authorization"] =
              "Bearer " + accessT;
            setFormError("");

            // Clean up unnecessary cookies (userData, idToken, amplify flags)
            // Keep only: accessToken, refreshToken, LastAuthUser, clockDrift
            try {
              await cleanupUnnecessaryCookies();
            } catch (err) {
              console.warn('Error cleaning up cookies:', err);
            }

            // Handle redirect after successful login
            const redirectPath = localStorage.getItem('redirectAfterLogin');
            localStorage.removeItem('is_extension_login');
            if (redirectPath) {
              localStorage.removeItem('redirectAfterLogin'); // Clean up
              // Validate and sanitize redirect URL to prevent open redirect attacks
              const safeUrl = getSafeRedirectUrl(redirectPath, '/');
              navigate(safeUrl);
              
              if (safeUrl !== redirectPath) {
                console.warn('Invalid redirect URL blocked:', redirectPath, '-> redirecting to:', safeUrl);
              }
            } else {
              navigate('/'); // Default redirect
            }
          });
        })
        .catch((error) => {
          console.error('Error during sign-in:', error);
          const errorMessage = error.message || error.toString() || '';
          
          // Check for maintenance mode errors from Cognito post_authentication trigger
          if (errorMessage.includes('MAINTENANCE_MODE') || error.response?.status === 503 || error.response?.data?.error === 'maintenance_mode') {
            setMaintenanceMode(true);
            setFormError("Maintenance Mode - The website is currently under maintenance. Please try again later.");
          } else if (errorMessage.includes('NEW_USER_REGISTRATION_DISABLED') || error.response?.status === 503 || error.response?.data?.error === 'new_user_login_disabled') {
            setNewUserLoginDisabled(true);
            setFormError("Maintenance Mode - New user registration is temporarily unavailable. Please try again later.");
          } else if (errorMessage.includes('LOGIN_DISABLED')) {
            setMaintenanceMode(true);
            setFormError("Maintenance Mode - Login is temporarily unavailable. Please try again later.");
          } else {
            setFormError(errorMessage || "Failed to sign in. Please try again.");
          }
        });
    } catch (error) {
      console.error('Error during sign-in:', error);
      const errorMessage = error.message || error.toString() || '';
      
      // Check for maintenance mode errors
      if (errorMessage.includes('MAINTENANCE_MODE') || errorMessage.includes('LOGIN_DISABLED')) {
        setMaintenanceMode(true);
        setFormError("Maintenance Mode - The website is currently under maintenance. Please try again later.");
      } else if (errorMessage.includes('NEW_USER_REGISTRATION_DISABLED')) {
        setNewUserLoginDisabled(true);
        setFormError("Maintenance Mode - New user registration is temporarily unavailable. Please try again later.");
      } else {
        setFormError(errorMessage || "Failed to sign in. Please try again.");
      }
    }
  };

  // Clear all old Cognito cookies when login page loads
  // Only clear if user is NOT authenticated (to avoid clearing active session)
  useEffect(() => {
    const clearOldCookiesIfNotAuthenticated = async () => {
      try {
        const { isAuthenticated } = await import('../../utils/authUtils');
        const authenticated = await isAuthenticated();
        // Only clear cookies if user is not authenticated
        // This prevents clearing active session when navigating to login page
        if (!authenticated) {
          clearAllCognitoCookies();
        }
      } catch (error) {
        // If check fails, assume not authenticated and clear cookies
        clearAllCognitoCookies();
      }
    };
    clearOldCookiesIfNotAuthenticated();
  }, []);

  // Check website configuration for maintenance mode
  useEffect(() => {
    const checkWebsiteConfiguration = async () => {
      try {
        const response = await axios.get(`${API_URL}/security/website-configuration`);
        if (response.data) {
          // First check if site is in maintenance mode
          if (response.data.in_maintenance) {
            setMaintenanceMode(true);
            setFormError("Maintenance Mode - The website is currently under maintenance. Please try again later.");
          } else if (!response.data.allow_login_new_user) {
            // Only check allow_login_new_user if not in maintenance
            setNewUserLoginDisabled(true);
          }
        }
      } catch (error) {
        console.error("Error checking website configuration:", error);
        // On error, allow login (fail open)
      }
    };
    checkWebsiteConfiguration();
  }, []);

  // Add message for invitations page
  useEffect(() => {
    const currentPath = window.location.pathname;
    if (currentPath === '/invitations') {
      setFormError("Please log in to view your invitations");
    }
  }, []);

  const [signUp, setSignUp] = useState(false);
  const handleOpenTermsAndConditions = () => {
    navigate('/terms');
  };

  const handleSignUp = () => {
    setFormError("");
    setSignUp(true);
  };

  // Password policy: at least 8 chars incl. one special character (matches ChangePassword)
  const validatePassword = (password) => /^(?=.*?[#?!@$%^&*-]).{8,}$/.test(password);

  const openForgotPassword = () => {
    setFormError("");
    setSuccessMsg("");
    setForgotEmail(form.email || "");
    setResetCode("");
    setForgotNewPassword("");
    setForgotStep(1);
    setForgotMode(true);
  };

  const closeForgotPassword = () => {
    setForgotMode(false);
    setForgotStep(1);
    setResetCode("");
    setForgotNewPassword("");
    setFormError("");
  };

  const sendResetCode = async () => {
    if (!validateEmail(forgotEmail)) {
      setFormError("Please enter a valid email address.");
      return;
    }
    setFormError("");
    setSuccessMsg("");
    setForgotSubmitting(true);
    try {
      await Auth.forgotPassword(forgotEmail);
      setSuccessMsg("We sent a reset code to your email. Enter it below with your new password.");
      setForgotStep(2);
    } catch (error) {
      console.error("Error sending reset code:", error);
      const msg = error?.message || error?.toString() || "";
      if (error?.code === "UserNotFoundException") {
        setFormError("No account found with that email address.");
      } else if (error?.code === "LimitExceededException") {
        setFormError("Too many attempts. Please try again later.");
      } else if (error?.code === "InvalidParameterException") {
        // Cognito throws this when the account has no verified email (e.g. social-only)
        setFormError("Password reset isn't available for this account. Try signing in with Google or Apple.");
      } else {
        setFormError(msg || "Failed to send reset code. Please try again.");
      }
    } finally {
      setForgotSubmitting(false);
    }
  };

  const submitNewPassword = async () => {
    if (!resetCode.trim()) {
      setFormError("Please enter the code from your email.");
      return;
    }
    if (!validatePassword(forgotNewPassword)) {
      setFormError("Password must be at least 8 characters and include a special character.");
      return;
    }
    setFormError("");
    setForgotSubmitting(true);
    try {
      await Auth.forgotPasswordSubmit(forgotEmail, resetCode.trim(), forgotNewPassword);
      closeForgotPassword();
      setSuccessMsg("Your password has been reset. Please sign in with your new password.");
    } catch (error) {
      console.error("Error resetting password:", error);
      const msg = error?.message || error?.toString() || "";
      if (error?.code === "CodeMismatchException") {
        setFormError("The code you entered is incorrect. Please check and try again.");
      } else if (error?.code === "ExpiredCodeException") {
        setFormError("This code has expired. Please request a new one.");
      } else if (error?.code === "InvalidPasswordException") {
        setFormError("Password does not meet the requirements. Please choose a stronger password.");
      } else if (error?.code === "LimitExceededException") {
        setFormError("Too many attempts. Please try again later.");
      } else {
        setFormError(msg || "Failed to reset password. Please try again.");
      }
    } finally {
      setForgotSubmitting(false);
    }
  };

  const handleForgotEnter = (e) => {
    if (e.key === "Enter") {
      if (forgotStep === 1) {
        sendResetCode();
      } else {
        submitNewPassword();
      }
    }
  };

  return (
    <>
      {signUp ? <SignUp setSignUp={setSignUp}
        onClickTermsAndConditions={() => handleOpenTermsAndConditions()} />
        : forgotMode ? (
          <div>
            <Grid container>
              <Grid
                item
                xs={12}
                style={{ display: "flex", alignItems: "center", padding: "5px 20px" }}
              ></Grid>
            </Grid>
            <Grid container style={{ justifyContent: "center" }}>
              <Grid item className="loginCard">
                {!!formError ? <Alert severity="error">{formError}</Alert> : null}
                {!!successMsg ? <Alert severity="success" sx={{ marginTop: "10px" }}>{successMsg}</Alert> : null}
                <Card style={{ padding: "30px", borderRadius: "15px" }}>
                  <Typography
                    variant="h6"
                    className="dataRateHeader"
                    style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/Datarate_logo_new.svg`}
                      style={{ height: "70px" }}
                      alt="Datarate Logo"
                    />
                  </Typography>

                  <div className="signInHeader">
                    <h2 className="signIn"> Reset Password</h2>
                  </div>

                  {forgotStep === 1 ? (
                    <>
                      <Typography variant="body2" style={{ marginTop: "8px", color: "rgba(71,85,105,0.8)" }}>
                        Enter your account email and we'll send you a reset code.
                      </Typography>
                      <TextField
                        name="forgotEmail"
                        hiddenLabel
                        fullWidth
                        className="loginTextfields"
                        label="Email"
                        value={forgotEmail}
                        onChange={(e) => setForgotEmail(e.target.value)}
                        onKeyDown={handleForgotEnter}
                        variant="standard"
                      />
                      <Button
                        className="connectButton"
                        variant="contained"
                        fullWidth
                        disabled={forgotSubmitting}
                        onClick={sendResetCode}
                      >
                        {forgotSubmitting ? "Sending..." : "Send reset code"}
                      </Button>
                    </>
                  ) : (
                    <>
                      <Typography variant="body2" style={{ marginTop: "8px", color: "rgba(71,85,105,0.8)" }}>
                        Enter the code sent to {forgotEmail} and choose a new password.
                      </Typography>
                      <TextField
                        name="resetCode"
                        hiddenLabel
                        fullWidth
                        className="loginTextfields"
                        label="Reset code"
                        value={resetCode}
                        onChange={(e) => setResetCode(e.target.value)}
                        onKeyDown={handleForgotEnter}
                        variant="standard"
                      />
                      <FormControl className="loginTextfields" fullWidth variant="standard">
                        <InputLabel htmlFor="forgot-new-password">New Password</InputLabel>
                        <Input
                          id="forgot-new-password"
                          type={forgotShowPassword ? "text" : "password"}
                          value={forgotNewPassword}
                          fullWidth
                          onChange={(e) => setForgotNewPassword(e.target.value)}
                          onKeyDown={handleForgotEnter}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => setForgotShowPassword(!forgotShowPassword)}
                                onMouseDown={handleMouseDownPassword}
                              >
                                {forgotShowPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                      <Button
                        className="connectButton"
                        variant="contained"
                        fullWidth
                        disabled={forgotSubmitting}
                        onClick={submitNewPassword}
                      >
                        {forgotSubmitting ? "Resetting..." : "Reset password"}
                      </Button>
                      <Link
                        className="cant_signIn"
                        component="button"
                        onClick={sendResetCode}
                        style={{ marginTop: "8px" }}
                      >
                        Resend code
                      </Link>
                    </>
                  )}

                  <Link
                    className="cant_signIn"
                    component="button"
                    onClick={closeForgotPassword}
                    style={{ marginTop: "8px" }}
                  >
                    Back to sign in
                  </Link>
                </Card>
              </Grid>
            </Grid>
          </div>
        )
        : <div>

          <Grid container>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "5px 20px",
              }}
            >

            </Grid>
          </Grid>
          <Grid container style={{ justifyContent: "center" }}>

            <Grid item className="loginCard">

              {!!successMsg ? <Alert severity="success" sx={{ marginBottom: "10px" }}>{successMsg}</Alert> : null}
              {!!formError ? <Alert severity="error">{formError}</Alert> : null}
              {maintenanceMode ? (
                <Card style={{ padding: "30px", borderRadius: "15px", textAlign: "center" }}>
                  <Typography
                    variant="h6"
                    className="dataRateHeader"
                    style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: "20px" }}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/Datarate_logo_new.svg`}
                      style={{ height: '70px' }}
                      alt="Datarate Logo"
                    />
                  </Typography>
                  <Typography variant="h5" style={{ marginBottom: "20px", color: "#d32f2f" }}>
                    Maintenance Mode
                  </Typography>
                  <Typography variant="body1" style={{ marginBottom: "10px" }}>
                    The website is currently under maintenance. Please try again later.
                  </Typography>
                  {formError && formError !== "Maintenance Mode" && (
                    <Typography variant="body2" style={{ color: "#d32f2f", marginTop: "10px" }}>
                      {formError}
                    </Typography>
                  )}
                </Card>
              ) : (
                <Card style={{ padding: "30px", borderRadius: "15px" }}>
                  <Typography
                    variant="h6"
                    className="dataRateHeader"
                    style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/Datarate_logo_new.svg`}
                      style={{ height: '70px' }}
                      alt="Datarate Logo"
                    />
                  </Typography>

                  <div className="signInHeader">
                    <h2 className="signIn"> Sign In</h2>
                    {!newUserLoginDisabled && (
                      <Link
                        className="dont_have_account"
                        component="button"
                        color="primary"
                        onClick={handleSignUp}
                      >
                        I don't have an account
                      </Link>
                    )}
                    {newUserLoginDisabled && (
                      <Typography variant="body2" style={{ color: "#d32f2f", marginTop: "10px" }}>
                        New user registration is temporarily unavailable
                      </Typography>
                    )}
                  </div>
                <TextField
                  name={"email"}
                  hiddenLabel
                  fullWidth
                  className="loginTextfields"
                  id="standard-basic"
                  label={"Email"}
                  value={form.email}
                  onChange={handleFormChange}
                  onKeyDown={handleEnterEventEmail}
                  variant="standard"
                  error={Boolean(errObj["email"])}
                  helperText={
                    !emailValidated
                      ? !form.email.length
                        ? "Required"
                        : errObj["email"]
                          ? "Invalid Email Address"
                          : ""
                      : ""
                  }
                />

                {continue_ && emailValidated && form.email.length ? (
                  <FormControl
                    className="loginTextfields"
                    fullWidth
                    variant="standard"
                  >
                    <InputLabel htmlFor="standard-adornment-password">
                      Password
                    </InputLabel>
                    <Input
                      onKeyDown={handleEnterEvent}
                      id="standard-adornment-password"
                      type={form.showPassword ? "text" : "password"}
                      value={form.password}
                      fullWidth
                      name="password"
                      onChange={handleFormChange}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                          >
                            {form.showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                ) : (
                  <></>
                )}

                {!(continue_ && emailValidated && form.email.length) ? (
                  <Button
                    className="connectButton"
                    variant="contained"
                    fullWidth
                    onClick={() => {
                      continueWithEmail();
                    }}
                  >
                    Continue
                  </Button>
                ) : (
                  <Button
                    className="connectButton"
                    variant="contained"
                    fullWidth
                    onClick={() => {
                      signIn();
                    }}
                  >
                    Sign in
                  </Button>
                )}
                <Link
                  className="cant_signIn"
                  component="button"
                  onClick={openForgotPassword}
                >
                  Can't Sign In?{" "}
                </Link>
                <Link className="signin_with" component="button">
                  OR SIGN IN WITH
                </Link>
                <Grid container spacing={2}>
                  <Grid textAlign="center" item xl={6} lg={4} md={12} xs={12}>
                    {/*<Button*/}
                    {/*  className="loginButtons"*/}
                    {/*  variant="outlined"*/}
                    {/*  startIcon={*/}
                    {/*    <Avatar*/}
                    {/*      sx={{ height: "20px", width: "20px" }}*/}
                    {/*      src={facebook}*/}
                    {/*    />*/}
                    {/*  }*/}
                    {/*  onClick={() => {*/}
                    {/*    signInWithFacebook();*/}
                    {/*  }}*/}
                    {/*>*/}
                    {/*  FACEBOOK*/}
                    {/*</Button>*/}
                  </Grid>
                  <Grid textAlign="center" item xl={6} lg={4} md={12} xs={12}>
                    <Button
                      className="loginButtons"
                      variant="outlined"
                      startIcon={
                        <Avatar
                          sx={{ height: "20px", width: "20px" }}
                          src={google}
                        />
                      }
                      onClick={() => {
                        signInWithGoogle();
                      }}
                    >
                      GOOGLE
                    </Button>
                  </Grid>
                  <Grid textAlign="center" item xl={6} lg={4} md={12} xs={12}>
                    <Button
                      className="loginButtons"
                      variant="outlined"
                      startIcon={
                        <Avatar
                          sx={{ height: "20px", width: "20px" }}
                          src={apple}
                        />
                      }
                      onClick={() => {
                        signInWithApple();
                      }}
                    >
                      APPLE
                    </Button>
                  </Grid>
                </Grid>
                <div>
                  <p className="terms-point">
                    By signing up, you agree to the
                    <Link className="terms_conds" component="button"
                      onClick={() => handleOpenTermsAndConditions()}

                    >
                      Terms and Conditions
                    </Link>
                    and
                    <Link className="terms_conds" component="button"
                      onClick={() => handleOpenTermsAndConditions()}

                    >
                      Privacy Policy
                    </Link>
                  </p>
                </div>

                <CardActions></CardActions>
              </Card>
              )}
            </Grid>

            {/* <Grid item xs={4}></Grid> */}
          </Grid>
        </div>}


    </>
  );
};

export default Login;
